module.exports = __webpack_public_path__ + "img/logo.4b5ce70c.png";